module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-11-5c975e7be9aad3427f81512af0ea9d6a.jpg";